import { createRouter, createWebHistory, createMemoryHistory, type RouteRecordRaw } from 'vue-router';
import { useAuthStore } from '../stores/auth.ts';

export const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue'),
    meta: { requiresAuth: false, title: 'Sign In' },
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: () => import('../views/LandingView.vue'),
    meta: { requiresAuth: false, title: 'Gateflow - Offline-First Access Control' },
  },
  {
    path: '/landing',
    redirect: () => ({ path: '/welcome' }),
  },
  {
    path: '/download',
    name: 'download',
    component: () => import('../views/DownloadView.vue'),
    meta: { requiresAuth: false, title: 'Download Kiosk APK - Gateflow' },
  },
  {
    path: '/apk',
    redirect: () => ({ path: '/download' }),
  },
  {
    path: '/policy',
    name: 'policy',
    component: () => import('../views/PolicyView.vue'),
    meta: { requiresAuth: false, title: 'Statutory Policy & Privacy Architecture' },
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/PolicyView.vue'),
    meta: { requiresAuth: false, title: 'Statutory Policy & Privacy Architecture' },
  },
  {
    path: '/',
    name: 'dashboard',
    component: () => import('../views/DashboardView.vue'),
    meta: { requiresAuth: true, title: 'Dashboard' },
  },
  {
    path: '/gate',
    name: 'gate',
    redirect: () => ({ path: '/', query: { tab: 'gate' } }),
    meta: { requiresAuth: true, title: 'Live Gate' },
  },
  {
    path: '/visitors',
    name: 'visitors',
    redirect: () => ({ path: '/', query: { tab: 'visitors' } }),
    meta: { requiresAuth: true, title: 'Visitors' },
  },
  {
    path: '/hosts',
    name: 'hosts',
    redirect: () => ({ path: '/', query: { tab: 'hosts' } }),
    meta: { requiresAuth: true, title: 'Hosts' },
  },
  {
    path: '/devices',
    name: 'devices',
    redirect: () => ({ path: '/', query: { tab: 'devices' } }),
    meta: { requiresAuth: true, title: 'Devices' },
  },
  {
    path: '/fleet',
    redirect: () => ({ path: '/', query: { tab: 'devices' } }),
  },
  {
    path: '/tenants',
    name: 'tenants',
    component: () => import('../views/TenantsView.vue'),
    meta: { requiresAuth: true, requiresSuperAdmin: true, title: 'Tenants' },
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/SettingsView.vue'),
    meta: { requiresAuth: true, title: 'Settings' },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
];

export const router = createRouter({
  history: typeof window !== 'undefined'
    ? createWebHistory(typeof import.meta !== 'undefined' ? import.meta.env?.BASE_URL : '/')
    : createMemoryHistory(),
  routes,
});

router.beforeEach((to, _from, next) => {
  const authStore = useAuthStore();
  const requiresAuth = to.meta.requiresAuth ?? true;
  const requiresSuperAdmin = to.meta.requiresSuperAdmin ?? false;

  if (requiresAuth && !authStore.isAuthenticated) {
    if (to.path === '/') {
      next({ path: '/welcome' });
      return;
    }
    if (to.path !== '/login') {
      next({ path: '/login', query: { redirect: to.fullPath } });
      return;
    }
  }

  if (requiresSuperAdmin && !authStore.isSuperAdmin) {
    next({ path: '/' });
    return;
  }

  next();
});

export default router;
